import React from "react";
import { useWallet } from "../../context/WalletContext";
import { shortAddr } from "../../utils/format";
import { LOGO_MARK } from "../../config/assets";
import BrandName from "../common/BrandName";

export default function TopBar() {
  const { account } = useWallet();
  return (
    <header className="topbar">
      <div className="topbar-logo">
        <img src={LOGO_MARK} alt="Nexaura" />
        <BrandName />
      </div>
      {account ? (
        <div className="wallet-chip">
          <span className="dot" />
          {shortAddr(account)}
        </div>
      ) : null}
    </header>
  );
}
